import React, { useEffect } from 'react';
import * as d3 from 'd3';
const WIDTH = 120;
const HEIGHT = 16;
const MARGIN = { top: 0, right: 0, bottom: 0, left: 0 };
const INNER_WIDTH = WIDTH - MARGIN.left - MARGIN.right;
const INNER_HEIGHT = HEIGHT - MARGIN.top - MARGIN.bottom;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function Sparkline({ index, data }) {

	const DATA_COUNT = data.length;
	useEffect(() => {
		//const data = d3.range(DATA_COUNT).map( d => Math.random() );
		const normalizeData = data.map(d => d / Math.max(...data));
		const x = d3.scaleLinear().domain([0, DATA_COUNT]).range([0, INNER_WIDTH]);
		const y = d3.scaleLinear().domain([0, 1.2]).range([INNER_HEIGHT, 0]);
		const svg = d3.selectAll(`#sparklines-${ index }`).html('svg')
			.attr('width', WIDTH)
			.attr('height', HEIGHT)
			.append('g')
			.attr('transform', 'translate(' + MARGIN.left + ',' + MARGIN.top + ')');
		const line = d3.line()
			.x((d, i) => x(i))
			.y(d => y(d));
		svg.append('path').datum(normalizeData)
			.attr('stroke', "rgb(89,91,243)")
			.attr('fill', 'none')
			.attr('stroke-width', 2)
			.attr('d', line)
			.transition()
			.duration(500)
			.ease(d3.easeLinear)
			.attrTween("stroke-dasharray", function() {
				const length = this.getTotalLength();
				return d3.interpolate(`0,${ length }`, `${ length },${ length }`);
			});


		const areaGenerator = d3.area()
			.x(function(d, i) {
				return x(i);
			})
			.y0(function() {
				return y(0);
			})
			.y1(function(d) {
				return y(d);
			});

		svg
			.append("path")
			.attr("d", areaGenerator(normalizeData))
			.attr("fill", "rgb(26,26,50)")
			.attr('opacity', 0)
			.transition()
			.duration(1000)
			.attr('opacity', 1);
		// .attr("fill", "rgb(26,26,50)")

	}, [DATA_COUNT, data, index]);


	return (
		<svg className="scorecard-sparkline" id={`sparklines-${ index }`}>
		</svg>
	);
}

export default Sparkline;
